import {
  AllCandidateBLASTUiParamsType,
  CommonBLASTParamValues,
  UnwrappedBLASTParamsType,
} from 'search/blast/parameters/common';
import pickDefined from 'util/pickDefined';

export type CandidateTBLASTXUiParamsType = Pick<
  AllCandidateBLASTUiParamsType<never>,
  'evalue' | 'word_size' | 'culling_limit' | 'strand' | 'matrix'
>;

export type TBLASTXUiParamsType = UnwrappedBLASTParamsType<CandidateTBLASTXUiParamsType>;

export const DefaultTBLASTXParams: CandidateTBLASTXUiParamsType = {
  ...pickDefined(CommonBLASTParamValues, 'evalue', 'culling_limit', 'strand', 'matrix'),
  word_size: {
    values: [2, 3],
    defaultValue: 3,
  },
};

export const getCandidateTBLASTXUiParams = (): CandidateTBLASTXUiParamsType => DefaultTBLASTXParams;
